import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["homeLink", "links"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { DESKTOP_NAV_HEIGHT } from '@infl-ts/ui-app-alerts';
import { AppBar, Box, Toolbar, useMediaQuery } from '@mui/material';
import { absurd, flow, pipe } from 'fp-ts/function';
import * as RA from 'fp-ts/ReadonlyArray';
import ActionBar from './action-bar';
import HomeLink from './action-bar/home-link';
import NavGroup from './nav-group';
import NavLink from './nav-link';
import { useFitLinksInNav } from './use-fit-links-in-nav';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MOBILE_NAV_HEIGHT = 48;

var getNavHeight = function getNavHeight(isMobile) {
  return isMobile ? MOBILE_NAV_HEIGHT : DESKTOP_NAV_HEIGHT;
};

var Links = function Links(_ref) {
  var content = _ref.content,
      isDesktop = _ref.isDesktop;

  switch (content.typename) {
    case 'NavBlockGroup':
      return /*#__PURE__*/_jsx(NavGroup, {
        content: content,
        sx: {
          px: 3,
          whiteSpace: 'nowrap'
        }
      });

    case 'NavBlockLogoGroup':
      return /*#__PURE__*/_jsx(NavGroup, {
        content: content,
        sx: {
          px: 3
        }
      });

    case 'NavBlockLink':
      return /*#__PURE__*/_jsx(NavLink, {
        link: content,
        sx: {
          px: 3,
          whiteSpace: 'nowrap'
        },
        isDesktop: isDesktop
      });

    case 'NavBlockLogoLink':
      return /*#__PURE__*/_jsx(NavLink, {
        link: content,
        sx: {
          px: 3
        },
        isDesktop: isDesktop
      });

    default:
      return absurd(content);
  }
};

var NavLinks = function NavLinks(_ref2) {
  var linksInMore = _ref2.linksInMore,
      links = _ref2.links,
      isDesktop = _ref2.isDesktop;
  return linksInMore === 0 ? /*#__PURE__*/_jsx(_Fragment, {
    children: links.map(function (content) {
      return /*#__PURE__*/_jsx(Links, {
        content: content,
        isDesktop: isDesktop
      }, content.id);
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: pipe(links, RA.splitAt(links.length - linksInMore), function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          shownLinks = _ref4[0],
          overflowLinks = _ref4[1];

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [shownLinks.map(function (content) {
          return /*#__PURE__*/_jsx(Links, {
            content: content,
            isDesktop: isDesktop
          }, content.id);
        }), /*#__PURE__*/_jsx(NavGroup, {
          content: {
            typename: 'NavBlockGroup',
            id: 'overflow-more',
            display: 'More',
            links: overflowLinks
          },
          sx: {
            mx: 2
          }
        })]
      });
    })
  });
};

var NavBlock = function NavBlock(_ref5) {
  var isDesktop = _ref5.isDesktop,
      _ref5$block = _ref5.block,
      homeLink = _ref5$block.homeLink,
      links = _ref5$block.links,
      rest = _objectWithoutProperties(_ref5$block, _excluded);

  var _useFitLinksInNav = useFitLinksInNav(links.length),
      toolbarRef = _useFitLinksInNav.toolbarRef,
      linksRef = _useFitLinksInNav.linksRef,
      actionsRef = _useFitLinksInNav.actionsRef,
      spaceRef = _useFitLinksInNav.spaceRef,
      overflowLinks = _useFitLinksInNav.overflowLinks;

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  return /*#__PURE__*/_jsx(AppBar, {
    position: "static",
    color: "inherit",
    sx: {
      backgroundColor: function backgroundColor(t) {
        return t.palette.background.paper;
      },
      boxShadow: 'none',
      borderBottom: function borderBottom(t) {
        return "1px solid ".concat(t.palette.divider);
      }
    },
    "data-element": "AppBar",
    "data-component": "NavBlock",
    "data-source-file": "nav-block.tsx",
    children: /*#__PURE__*/_jsxs(Toolbar, {
      ref: toolbarRef,
      sx: {
        mx: 'auto',
        flexWrap: isDesktop ? 'nowrap' : 'wrap',
        justifyContent: function justifyContent(theme) {
          return theme.site.navbarAlignment === 'right' ? 'center' : 'space-between';
        },
        width: 1,
        minHeight: getNavHeight(isMobile),
        height: getNavHeight(isMobile),
        px: {
          xs: 2,
          md: 3
        },
        flexFlow: 'row'
      },
      "data-element": "Toolbar",
      "data-component": "NavBlock",
      "data-source-file": "nav-block.tsx",
      children: [/*#__PURE__*/_jsxs(Box, {
        ref: linksRef,
        sx: {
          display: 'inline-flex',
          alignItems: 'center',
          height: '64px',
          justifyContent: function justifyContent(theme) {
            return theme.site.navbarAlignment;
          },
          minWidth: {
            xs: 0,
            md: 'auto'
          },
          width: function width(theme) {
            return theme.site.navbarAlignment === 'right' ? '100%' : 'unset';
          }
        },
        "data-element": "Box",
        "data-component": "NavBlock",
        "data-source-file": "nav-block.tsx",
        children: [homeLink ? /*#__PURE__*/_jsx(HomeLink, {
          homeLink: homeLink,
          isDesktop: isDesktop
        }) : null, isDesktop && /*#__PURE__*/_jsx(NavLinks, {
          linksInMore: overflowLinks,
          links: links,
          isDesktop: isDesktop
        })]
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          flexGrow: 1
        },
        ref: spaceRef,
        "data-element": "Box",
        "data-source-file": "nav-block.tsx"
      }), /*#__PURE__*/_jsx(Box, {
        ref: actionsRef,
        "data-element": "Box",
        "data-source-file": "nav-block.tsx",
        children: /*#__PURE__*/_jsx(ActionBar, _objectSpread(_objectSpread({
          isDesktop: isDesktop,
          links: links,
          memberMessagingEnabled: true
        }, rest), {}, {
          "data-element": "ActionBar",
          "data-source-file": "nav-block.tsx"
        }))
      })]
    })
  });
};

var useProps = function useProps(_ref6) {
  var block = _ref6.block;
  return {
    isDesktop: useMediaQuery(function (theme) {
      return theme.breakpoints.up('lg');
    }),
    block: block
  };
};

export default Object.assign(flow(useProps, NavBlock), {
  displayName: 'NavBlock'
});